import styled from 'styled-components';
import { CommonDetails } from '../common-styles.styles';

export const Details = styled(CommonDetails)`
  line-height: 1.5;
  h3 {
    color: #000000;
    padding-bottom: ${props => props.theme.spacing.custom(10)};
  }
`;
